import React from 'react';
import {Link} from 'react-router-dom';
import {NavItem, NavLink} from 'reactstrap';
import {Rocket} from 'lucide-react';
import {RoutePaths} from '../../../RoutePaths';
import {useGettingStarted} from '../../../api/gettingStarted/useGettingStarted';
import {
    gettingStartedProgress,
    shouldPromptGettingStarted
} from '../../../lib/gettingStarted';

/**
 * A small "Getting started 3 of 6" link in the top bar while the checklist's
 * required steps aren't done. Gone once they are, or once the person hides the
 * reminders; the account menu keeps the page reachable either way.
 */
const GettingStartedNavPill: React.FC<{active: boolean}> = ({active}) => {
    const {data: status} = useGettingStarted();

    if (!status || !shouldPromptGettingStarted(status)) {
        return null;
    }

    return (
        <NavItem active={active}>
            <NavLink
                tag={Link}
                to={RoutePaths.gettingStarted()}
                className="d-flex align-items-center gap-1 text-nowrap"
                title="Getting started: what to set up next"
            >
                <Rocket size={16} />
                <span>Getting started</span>
                <span className="badge rounded-pill text-bg-primary ms-1">
                    {gettingStartedProgress(status)}
                </span>
            </NavLink>
        </NavItem>
    );
};

export default GettingStartedNavPill;
